export const TOGGLE_VERIFY_DRAWER = 'TOGGLE_VERIFY_DRAWER'
export const TOGGLE_VERIFY_DRAWER_MOB = 'TOGGLE_VERIFY_DRAWER_MOB'
